<div class="comparison-container">
  <div class="column original">
    <h5 class="company-profile-header">
      {{ 'label.CompanyProfile' | translate }}
    </h5>
    <div class="company-cover-image-placeholder">
      <label>{{ 'label.CompanyCoverImage' | translate }}</label>
      <img
        [src]="
          customer.originalCustomer.coverImage
            ? customer.originalCustomer.coverImage
            : 'assets/img/customer_no_cover_photo.svg'
        "
        alt="Original Image"
        class="company-image"
      />
    </div>
    <div class="company-logos-placeholder">
      <div class="company-logo">
        <label>{{ 'label.CompanyLogo' | translate }}</label>
        <img
          [src]="
            customer.originalCustomer.logoFilename
              ? customer.originalCustomer.logoFilename
              : 'assets/img/company_no_logo.svg'
          "
          alt="Original Image"
          class="company-logo-image"
        />
      </div>
      <div class="company-list-logo">
        <label>{{ 'label.CompanyListLogo' | translate }}</label>
        <img
          [src]="
            customer.originalCustomer.logoThumbnail1Filename
              ? customer.originalCustomer.logoThumbnail1Filename
              : 'assets/img/company_no_logo_for_list.svg'
          "
          alt="Original Image"
          class="company-list-logo-image"
        />
      </div>
    </div>
    <div class="form-group">
      <label>{{ 'label.CompanyName' | translate }}:</label>
      <span>{{
        customer.originalCustomer.name || ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label>{{ 'label.CompanyNameOnOtherLanguage' | translate }}:</label>
      <span>{{
        customer.originalCustomer.name2 || ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label>{{ 'label.Industry' | translate }}:</label>
      <span
        *ngFor="
          let industry of customer.originalCustomer.industryNameList;
          let last = last
        "
      >
        {{ last ? industry : industry + ', ' }}
      </span>
    </div>
    <div class="form-group">
      <label>{{ 'label.NumberOfEmployees' | translate }}:</label>
      <span>
        {{
          getEmployeesLabel(
            customer.originalCustomer.numberOfEmployeesFrom,
            customer.originalCustomer.numberOfEmployeesTo
          )
        }}
      </span>
    </div>
    <div class="form-group">
      <label>{{ 'label.Location' | translate }}:</label>
      <span>{{
        customer.originalCustomer.city?.name ||
          ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label>{{ 'label.Website' | translate }}:</label>
      <span>{{
        customer.originalCustomer.website || ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label>{{ 'label.PublicEmail' | translate }}:</label>
      <span>{{
        customer.originalCustomer.publicEmail ||
          ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label>{{ 'label.Description' | translate }}:</label>
      <div class="original-description" #originalDescription>
        <span
          [innerHtml]="
            customer.originalCustomer.description
              ? (customer.originalCustomer.description | safeHtml)
              : ''
          "
        ></span>
      </div>
    </div>
    <div class="branding-desktop">
      <label>{{ 'label.BrandingDesktopVersion' | translate }}</label>
      <img
        [src]="
          customer.originalCustomer.announcementDetailsDesktopBgImage
            ? customer.originalCustomer.announcementDetailsDesktopBgImage
            : 'assets/img/no_branding_desktop.jpg'
        "
        alt="Original Image"
        class="branding-desktop-image"
        [ngClass]="{
          'no-image-border':
            !customer.originalCustomer.announcementDetailsDesktopBgImage
        }"
      />
    </div>
    <div class="branding-mobile">
      <label>{{ 'label.BrandingMobileVersion' | translate }}</label>

      <img
        [src]="
          customer.originalCustomer.announcementDetailsMobileBgImage
            ? customer.originalCustomer.announcementDetailsMobileBgImage
            : 'assets/img/no_branding_list.png'
        "
        alt="Original Image"
        class="branding-desktop-image"
        [ngClass]="{
          'no-image-border':
            !customer.originalCustomer.announcementDetailsMobileBgImage
        }"
      />
    </div>
    <div class="tile-colors">
      <div class="announcement-tile-color-container">
        <label>{{ 'label.AnnouncementDetailsTileColor' | translate }}</label>
        <div class="announcement-color">
          <span>{{
            customer.originalCustomer.announcementDetailsBgColor | uppercase
          }}</span>
          <div
            class="round-tile"
            [style]="{
              'background-color':
                customer.originalCustomer.announcementDetailsBgColor
            }"
          ></div>
        </div>
      </div>
      <div class="announcement-list-color-container">
        <label>{{ 'label.AnnouncementListTileColor' | translate }}</label>
        <div class="announcement-list-color">
          <span>{{
            customer.originalCustomer.announcementTileColor | uppercase
          }}</span>
          <div
            class="round-tile"
            [style]="{
              'background-color':
                customer.originalCustomer.announcementTileColor
            }"
          ></div>
        </div>
      </div>
      <div class="company-tile-color-container">
        <label>{{ 'label.CompanyProfileTileColor' | translate }}</label>
        <div class="company-profile-color">
          <span>{{
            customer.originalCustomer.customerDetailsBgColor | uppercase
          }}</span>
          <div
            class="round-tile"
            [style]="{
              'background-color':
                customer.originalCustomer.customerDetailsBgColor
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Changed Profile -->
  <div class="column changed">
    <h5 class="company-profile-header">
      {{ 'label.CompanyProfile' | translate }}
    </h5>
    <div class="company-cover-image-placeholder">
      <label
        [ngClass]="{
          'changed-label': customer.changes.brandingEntityAttributes.includes(
            brandingEntityAttributes.CoverImage
          )
        }"
        >{{ 'label.CompanyCoverImage' | translate }}</label
      >
      <img
        [src]="
          customer.editedCustomer.coverImage
            ? customer.editedCustomer.coverImage
            : 'assets/img/customer_no_cover_photo.svg'
        "
        alt="Updated Image"
        class="company-image"
      />
    </div>
    <div class="company-logos-placeholder">
      <div class="company-logo">
        <label
          [ngClass]="{
            'changed-label': customer.changes.customerEntityAttributes.includes(
              customerEntityAttributes.Logo
            )
          }"
          >{{ 'label.CompanyLogo' | translate }}</label
        >
        <img
          [src]="
            customer.editedCustomer.logoFilename
              ? customer.editedCustomer.logoFilename
              : 'assets/img/company_no_logo.svg'
          "
          alt="Original Image"
          class="company-logo-image"
        />
      </div>
      <div class="company-list-logo">
        <label
          [ngClass]="{
            'changed-label': customer.changes.customerEntityAttributes.includes(
              customerEntityAttributes.LogoThumbnail
            )
          }"
          >{{ 'label.CompanyListLogo' | translate }}</label
        >
        <img
          [src]="
            customer.editedCustomer.logoThumbnail1Filename
              ? customer.editedCustomer.logoThumbnail1Filename
              : 'assets/img/company_no_logo_for_list.svg'
          "
          alt="Original Image"
          class="company-list-logo-image"
        />
      </div>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.Name
          )
        }"
        >{{ 'label.CompanyName' | translate }}:</label
      >
      <span>
        {{ customer.editedCustomer.name }}
      </span>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.Name2
          )
        }"
        >{{ 'label.CompanyNameOnOtherLanguage' | translate }}:</label
      >
      <span>
        {{ customer.editedCustomer.name2 }}
      </span>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.Industry
          )
        }"
        >{{ 'label.Industry' | translate }}:</label
      >
      <span
        *ngFor="
          let industry of customer.editedCustomer.industryNameList;
          let last = last
        "
        >{{ last ? industry : industry + ', ' }}</span
      >
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.NumberOfEmployees
          )
        }"
        >{{ 'label.NumberOfEmployees' | translate }}:</label
      >
      <span>
        {{
          getEmployeesLabel(
            customer.editedCustomer.numberOfEmployeesFrom,
            customer.editedCustomer.numberOfEmployeesTo
          )
        }}
      </span>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.City
          )
        }"
        >{{ 'label.Location' | translate }}:</label
      >
      <span>
        {{ customer.editedCustomer.city?.name || ('NotSelected' | i18nLabel) }}
      </span>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.Website
          )
        }"
        >{{ 'label.Website' | translate }}:</label
      >
      <span>{{
        customer.editedCustomer.website || ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.PublicEmail
          )
        }"
        >{{ 'label.PublicEmail' | translate }}:</label
      >
      <span>{{
        customer.editedCustomer.publicEmail || ('label.NotSelected' | translate)
      }}</span>
    </div>
    <div class="form-group">
      <label
        [ngClass]="{
          'changed-label': customer.changes.customerEntityAttributes.includes(
            customerEntityAttributes.Description
          )
        }"
        >{{ 'label.Description' | translate }}:</label
      >
      <div class="edited-description" #editedDescription>
        <span
          [innerHTML]="
            customer.editedDescription
              ? (customer.editedDescription | safeHtml)
              : ''
          "
        ></span>
      </div>
    </div>
    <div class="branding-desktop">
      <label
        [ngClass]="{
          'changed-label': customer.changes.brandingEntityAttributes.includes(
            brandingEntityAttributes.AnnouncementDetailsDesktopBgImage
          )
        }"
        >{{ 'label.BrandingDesktopVersion' | translate }}</label
      >

      <img
        [src]="
          customer.editedCustomer.announcementDetailsDesktopBgImage
            ? customer.editedCustomer.announcementDetailsDesktopBgImage
            : 'assets/img/no_branding_desktop.jpg'
        "
        alt="Original Image"
        class="branding-desktop-image"
        [ngClass]="{
          'no-image-border':
            !customer.editedCustomer.announcementDetailsDesktopBgImage
        }"
      />
    </div>
    <div class="branding-mobile">
      <label
        [ngClass]="{
          'changed-label': customer.changes.brandingEntityAttributes.includes(
            brandingEntityAttributes.AnnouncementDetailsMobileBgImage
          )
        }"
        >{{ 'label.BrandingMobileVersion' | translate }}</label
      >

      <img
        [src]="
          customer.editedCustomer.announcementDetailsMobileBgImage
            ? customer.editedCustomer.announcementDetailsMobileBgImage
            : 'assets/img/no_branding_list.png'
        "
        alt="Original Image"
        class="branding-mobile-image"
        [ngClass]="{
          'no-image-border':
            !customer.editedCustomer.announcementDetailsMobileBgImage
        }"
      />
    </div>
    <div class="tile-colors">
      <div class="announcement-tile-color-container">
        <label
          [ngClass]="{
            'changed-label': customer.changes.brandingEntityAttributes.includes(
              brandingEntityAttributes.AnnouncementDetailsBgColor
            )
          }"
          >{{ 'label.AnnouncementDetailsTileColor' | translate }}</label
        >
        <div class="announcement-color">
          <span>{{
            customer.editedCustomer.announcementDetailsBgColor | uppercase
          }}</span>
          <div
            class="round-tile"
            [style]="{
              'background-color':
                customer.editedCustomer.announcementDetailsBgColor
            }"
          ></div>
        </div>
      </div>
      <div class="announcement-list-color-container">
        <label
          [ngClass]="{
            'changed-label': customer.changes.brandingEntityAttributes.includes(
              brandingEntityAttributes.AnnouncementTileColor
            )
          }"
          >{{ 'label.AnnouncementListTileColor' | translate }}</label
        >
        <div class="announcement-list-color">
          <span>{{
            customer.editedCustomer.announcementTileColor | uppercase
          }}</span>
          <div
            class="round-tile"
            [style]="{
              'background-color': customer.editedCustomer.announcementTileColor
            }"
          ></div>
        </div>
      </div>
      <div class="company-tile-color-container">
        <label
          [ngClass]="{
            'changed-label': customer.changes.brandingEntityAttributes.includes(
              brandingEntityAttributes.CustomerDetailsBgColor
            )
          }"
          >{{ 'label.CompanyProfileTileColor' | translate }}</label
        >
        <div class="company-profile-color">
          <span>{{
            customer.editedCustomer.customerDetailsBgColor | uppercase
          }}</span>
          <div
            class="round-tile"
            [style]="{
              'background-color': customer.editedCustomer.customerDetailsBgColor
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <div class="refresh-page">
        <button (click)="getCustomerData()">
          <svg-icon
            src="assets/img/refresh_page.svg"
            [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
          ></svg-icon
          ><span>{{ 'label.RenewAnnouncement' | translate }}</span>
        </button>
        <div class="customer-profile">
          <div (click)="onLoginAsCustomer(customerId)" class="customer-login">
            <svg-icon
              src="assets/img/go_to_company_profile.svg"
              [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
            ></svg-icon
            ><span>{{ 'label.GoToCompanyProfile' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="buttons-head">
        <div class="button-container">
          <button
            class="reject"
            (click)="onReject(customer.customerModerationId)"
          >
            {{ 'label.Reject' | translate }}
          </button>
          <button
            class="approve"
            (click)="onApprove(customer.customerModerationId)"
          >
            {{ 'label.ConfirmChanges' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
